<div class="row">
  <div class="col">
    <span translate>ITEM</span>
  </div>
  <div class="col-sm-2">
    <span translate>QUANTITY</span>
  </div>
  <div class="col-sm-2">
    <span translate>PRICE</span>
  </div>
  <div class="col-sm-2">
    <span translate>DISCOUNT_PERCENT</span>
  </div>
  <div class="col">
    <span translate>TOTAL</span>
  </div>
</div>
<span *ngFor="let cartRow of data">
  <cult-sales-cart-row
    *ngIf="cachedData[cartRow.productId]"
    [data]="{
      cartRow: cartRow,
      product: cachedData[cartRow.productId].product,
      price: cachedData[cartRow.productId].price
    }"
  ></cult-sales-cart-row>
</span>
<!-- <div class="row" *ngFor="let cartRow of data"> -->
<!-- <cult-sales-cart-row
    *ngIf="cachedData[cartRow.productId]"
    [data]="{
      cartRow: cartRow,
      product: cachedData[cartRow.productId].product,
      price: cachedData[cartRow.productId].price
    }"
  ></cult-cult-sales-cart-row> -->
<!-- </div> -->
